import _objectWithoutProperties from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
var _excluded = ["field", "entity", "changeEntity", "children"],
    _excluded2 = ["data"],
    _excluded3 = ["created", "changed"],
    _excluded4 = ["attributes"],
    _excluded5 = ["uid"],
    _excluded6 = ["relationships"];
import "core-js/modules/es.typed-array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/home/forge/bpfd-stage.parallelpublicworks.com/frontend/node_modules/@babel/runtime/regenerator";
import React, { useEffect, createContext, useContext, Fragment as Fragment$1, useState, useRef } from 'react';
import docCookies from 'mozilla-doc-cookies';
import Subrequests from 'd8-subrequests';
import { get, del, set } from 'idb-keyval';

function saveLocal(userData) {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.setItem('entitysync_user_data', JSON.stringify(userData));
}

function getLocal() {
  if (typeof window === "undefined") {
    return false;
  }

  var userData = localStorage.getItem('entitysync_user_data');

  if (userData) {
    return JSON.parse(userData);
  }

  return null;
}

function getLocalEntity(entity) {
  var userData = getLocal();

  if (userData) {
    if (entity.id && userData[entity.id]) {
      return userData[entity.id];
    }

    if (entity.local_id && userData[entity.local_id]) {
      return userData[entity.local_id];
    }
  }

  return null;
}

function getLocalCurrentUser() {
  return localStorage.getItem("entitysync_current_user");
}

function setLocalCurrentUser(id) {
  return localStorage.setItem("entitysync_current_user", id);
}

var axios = require('axios');

function checkIfDuplicateModification(body) {
  return body.hasOwnProperty('errors') && body.errors.length === 1 && body.errors[0].status === "422" && body.errors[0].hasOwnProperty('detail') && body.errors[0].detail === "Entity is not valid: The content has either been modified by another user, or you have already submitted modifications. As a result, your changes cannot be saved.";
}

function getBaseUrl() {
  if (!process.env.REACT_APP_ENTITYSYNC_BASE_URL) {
    console.log(process.env);
    throw new Error("Missing base url for Entity Sync. Please set the REACT_APP_ENTITYSYNC_BASE_URL environment variable to the base url of your backend, like 'https://www.my-backend.com'");
  }

  return process.env.REACT_APP_ENTITYSYNC_BASE_URL.replace(/\/$/, "");
}

function getClientId() {
  if (!process.env.REACT_APP_ENTITYSYNC_CLIENT_ID) {
    throw new Error("Missing client ID for Entity Sync. Please set the REACT_APP_ENTITYSYNC_CLIENT_ID environment variable to the OAuth client_id of your app.");
  }

  return process.env.REACT_APP_ENTITYSYNC_CLIENT_ID;
}

function getPath(defaultEndpoint, endpointEnvVar) {
  var endpoint = defaultEndpoint;

  if (process.env[endpointEnvVar]) {
    endpoint = process.env[endpointEnvVar];
  }

  return endpoint.replace(/\/$/, "").replace(/^\//, "");
}

var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);

    this.token = typeof window !== "undefined" && docCookies.hasItem('refresh_token') && docCookies.hasItem('access_token') ? {
      refresh_token: docCookies.getItem('refresh_token'),
      access_token: docCookies.getItem('access_token')
    } : false;
    this.handleLogin = this.handleLogin.bind(this);
    this.isLoggedIn = this.isLoggedIn.bind(this);
  }

  _createClass(Auth, [{
    key: "verifyResponse",
    value: function () {
      var _verifyResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resp) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!/2../.test(resp.status.toString())) {
                  _context.next = 6;
                  break;
                }

                if (!(resp.status === 204)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", true);

              case 3:
                _context.next = 5;
                return resp.json();

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
                return _context.abrupt("return", false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function verifyResponse(_x) {
        return _verifyResponse.apply(this, arguments);
      }

      return verifyResponse;
    }()
  }, {
    key: "authSubrequest",
    value: function () {
      var _authSubrequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requests) {
        var subrequestsBase, baseUrl, subrequestEndpoint, subrequest, authHeaders, masterRequest, subresponse, subresponseHandler;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                subrequestsBase = getPath('subrequests', 'REACT_APP_ENTITYSYNC_SUBREQUESTS_BASE');
                baseUrl = getBaseUrl();

                if (!requests) {
                  _context2.next = 23;
                  break;
                }

                subrequestEndpoint = "".concat(baseUrl, "/").concat(subrequestsBase, "?_format=json");
                subrequest = new Subrequests(subrequestEndpoint);
                authHeaders = {
                  'Authorization': "Bearer ".concat(this.token.access_token),
                  'Content-Type': 'application/vnd.api+json'
                };
                masterRequest = {
                  headers: authHeaders
                };
                requests.map(function (request) {
                  subrequest.add(request);
                });
                _context2.next = 10;
                return axios.get(subrequest.getUrl(), masterRequest);

              case 10:
                subresponse = _context2.sent;

                subresponseHandler = function subresponseHandler(response) {
                  var parsedResponses = {};

                  for (var _i = 0, _Object$entries = Object.entries(response.data); _i < _Object$entries.length; _i++) {
                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                        key = _Object$entries$_i[0],
                        value = _Object$entries$_i[1];

                    if (value.hasOwnProperty('body')) {
                      parsedResponses[key] = JSON.parse(value.body);
                    }
                  }

                  return parsedResponses;
                };

                if (!(subresponse.status == 207)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return", subresponseHandler(subresponse));

              case 16:
                _context2.next = 18;
                return this.refresh();

              case 18:
                _context2.next = 20;
                return axios.get(subrequest.getUrl(), masterRequest);

              case 20:
                subresponse = _context2.sent;

                if (!(subresponse.status == 207)) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("return", subresponseHandler(subresponse));

              case 23:
                return _context2.abrupt("return", false);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function authSubrequest(_x2) {
        return _authSubrequest.apply(this, arguments);
      }

      return authSubrequest;
    }()
  }, {
    key: "drupalFetch",
    value: function () {
      var _drupalFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(jsonapiEndpoint) {
        var method,
            body,
            headers,
            base,
            jsonapiBase,
            url,
            init,
            resp,
            validResponse,
            newToken,
            secondResp,
            _validResponse,
            _body,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                method = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'GET';
                body = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
                headers = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;

                if (body && !(body instanceof File)) {
                  body = JSON.stringify(body);
                }

                base = getBaseUrl();
                jsonapiBase = getPath('jsonapi', 'REACT_APP_ENTITYSYNC_JSONAPI_BASE');
                url = "".concat(base, "/").concat(jsonapiBase, "/").concat(jsonapiEndpoint);
                init = {
                  method: method,
                  headers: {
                    'Authorization': "Bearer ".concat(this.token.access_token),
                    'Content-Type': 'application/vnd.api+json'
                  }
                };
                Object.assign(init.headers, headers);

                if (body) {
                  init.body = body;
                }

                _context3.next = 12;
                return fetch(url, init);

              case 12:
                resp = _context3.sent;
                _context3.next = 15;
                return this.verifyResponse(resp);

              case 15:
                validResponse = _context3.sent;

                if (!validResponse) {
                  _context3.next = 20;
                  break;
                }

                return _context3.abrupt("return", validResponse);

              case 20:
                if (!(resp.status === 401 || resp.status === 403)) {
                  _context3.next = 37;
                  break;
                }

                _context3.next = 23;
                return this.refresh();

              case 23:
                newToken = _context3.sent;

                if (!newToken) {
                  _context3.next = 35;
                  break;
                }

                init.headers = {
                  'Authorization': "Bearer ".concat(newToken.access_token),
                  'Content-Type': 'application/vnd.api+json'
                };
                Object.assign(init.headers, headers);
                _context3.next = 29;
                return fetch(url, init);

              case 29:
                secondResp = _context3.sent;
                _context3.next = 32;
                return this.verifyResponse(secondResp);

              case 32:
                _validResponse = _context3.sent;

                if (!_validResponse) {
                  _context3.next = 35;
                  break;
                }

                return _context3.abrupt("return", _validResponse);

              case 35:
                _context3.next = 43;
                break;

              case 37:
                if (!(resp.status === 422)) {
                  _context3.next = 43;
                  break;
                }

                _context3.next = 40;
                return resp.json();

              case 40:
                _body = _context3.sent;

                if (!checkIfDuplicateModification(_body)) {
                  _context3.next = 43;
                  break;
                }

                return _context3.abrupt("return", _body);

              case 43:
                return _context3.abrupt("return", false);

              case 44:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function drupalFetch(_x3) {
        return _drupalFetch.apply(this, arguments);
      }

      return drupalFetch;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var refreshToken;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                refreshToken = false;

                if (typeof window !== "undefined") {
                  refreshToken = docCookies.getItem('refresh_token');
                }

                if (!(typeof refreshToken !== "undefined" && refreshToken)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return this.authPost('refresh_token', refreshToken);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                return _context4.abrupt("return", false);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      return this.token ? true : false;
    }
  }, {
    key: "authPost",
    value: function () {
      var _authPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(grantType) {
        var authValue,
            form,
            base,
            url,
            formData,
            init,
            resp,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                authValue = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
                form = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
                base = getBaseUrl();
                url = base + '/oauth/token';
                formData = form ? form : new FormData();

                if (authValue) {
                  formData.append(grantType, authValue);
                }

                formData.append('grant_type', grantType);
                formData.append('client_id', getClientId());
                init = {
                  method: 'POST',
                  body: formData
                };
                _context5.prev = 9;
                _context5.next = 12;
                return fetch(url, init);

              case 12:
                resp = _context5.sent;
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](9);
                console.log(_context5.t0);

              case 18:
                if (!(resp && resp.status === 200)) {
                  _context5.next = 26;
                  break;
                }

                _context5.next = 21;
                return resp.json();

              case 21:
                this.token = _context5.sent;

                if (typeof window !== "undefined") {
                  docCookies.setItem('refresh_token', this.token.refresh_token, Infinity, '/');
                  docCookies.setItem('access_token', this.token.access_token, Infinity, '/');
                }

                return _context5.abrupt("return", this.token);

              case 26:
                if (typeof window !== "undefined") {
                  docCookies.removeItem('refresh_token');
                  docCookies.removeItem('access_token');
                }

                return _context5.abrupt("return", false);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[9, 15]]);
      }));

      function authPost(_x4) {
        return _authPost.apply(this, arguments);
      }

      return authPost;
    }()
  }, {
    key: "loginUser",
    value: function () {
      var _loginUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(formData, dispatch, grantType) {
        var _this2 = this;

        var _this, initialLoginResponse;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this = this;
                _context7.next = 3;
                return this.authPost(grantType, null, formData);

              case 3:
                initialLoginResponse = _context7.sent;

                if (initialLoginResponse) {
                  this.drupalFetch('/').then(function (isMe) {
                    if (typeof isMe.meta !== "undefined" && typeof isMe.meta.links.me !== "undefined") {
                      var uid = isMe.meta.links.me.meta.id;

                      _this2.drupalFetch('user/user/' + uid + '?include=roles').then( /*#__PURE__*/function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(userData) {
                          var localUserData, scopes;
                          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                            while (1) {
                              switch (_context6.prev = _context6.next) {
                                case 0:
                                  if (userData.data) {
                                    localUserData = getLocal();
                                    if (!localUserData) localUserData = {};
                                    localUserData[userData.data.id] = userData.data;
                                    saveLocal(localUserData);
                                    setLocalCurrentUser(userData.data.id);
                                    dispatch({
                                      type: "SET_CURRENT_USER_ENTITY",
                                      data: userData.data
                                    });
                                  }

                                  if (!userData.hasOwnProperty('included')) {
                                    _context6.next = 9;
                                    break;
                                  }

                                  scopes = [];
                                  userData.included.map(function (include) {
                                    if (include.type === 'user_role--user_role') {
                                      scopes.push(include.attributes.drupal_internal__id);
                                    }
                                  });

                                  if (!scopes) {
                                    _context6.next = 9;
                                    break;
                                  }

                                  formData.append('scope', scopes.join(' '));
                                  _context6.next = 8;
                                  return _this.authPost('password', null, formData);

                                case 8:
                                  return _context6.abrupt("return", _context6.sent);

                                case 9:
                                case "end":
                                  return _context6.stop();
                              }
                            }
                          }, _callee6);
                        }));

                        return function (_x8) {
                          return _ref.apply(this, arguments);
                        };
                      }());

                      return {
                        token: initialLoginResponse,
                        uid: uid
                      };
                    }
                  });
                }

                return _context7.abrupt("return", {
                  token: initialLoginResponse,
                  uid: null
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loginUser(_x5, _x6, _x7) {
        return _loginUser.apply(this, arguments);
      }

      return loginUser;
    }()
  }, {
    key: "handleLogin",
    value: function () {
      var _handleLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(event, dispatch) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                formData = new FormData(event.target);
                _context8.next = 3;
                return this.loginUser(formData, dispatch, 'password');

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleLogin(_x9, _x10) {
        return _handleLogin.apply(this, arguments);
      }

      return handleLogin;
    }()
  }, {
    key: "logoutUser",
    value: function () {
      var _logoutUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(typeof window !== "undefined")) {
                  _context9.next = 8;
                  break;
                }

                docCookies.removeItem('refresh_token', '/');
                docCookies.removeItem('access_token', '/');
                localStorage.clear();
                this.token = false;
                return _context9.abrupt("return", !docCookies.hasItem('refresh_token'));

              case 8:
                return _context9.abrupt("return", true);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function logoutUser() {
        return _logoutUser.apply(this, arguments);
      }

      return logoutUser;
    }()
  }]);

  return Auth;
}();

function mergeDeep(target, source) {
  var ret = _objectSpread(_objectSpread({}, target), source);

  for (var _i2 = 0, _Object$keys = Object.keys(target); _i2 < _Object$keys.length; _i2++) {
    var targetKey = _Object$keys[_i2];

    if (source.hasOwnProperty(targetKey) && typeof source[targetKey] === 'object' && typeof target[targetKey] === 'object' && source[targetKey] !== null && target[targetKey] !== null && (!Array.isArray(target[targetKey]) || !Array.isArray(source[targetKey]))) {
      ret[targetKey] = mergeDeep(target[targetKey], source[targetKey]);
    } else if (source.hasOwnProperty(targetKey)) {
      ret[targetKey] = source[targetKey];
    } else {
      ret[targetKey] = target[targetKey];
    }
  }

  return ret;
}

function compareDeepMerge(target, source) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  for (var _i3 = 0, _Object$keys2 = Object.keys(source); _i3 < _Object$keys2.length; _i3++) {
    var sourceKey = _Object$keys2[_i3];

    if (typeof source[sourceKey] === 'object' && typeof target[sourceKey] === 'object' && source[sourceKey] !== null && target[sourceKey] !== null) {
      if (parentKey === 'relationships') {
        if (!source[sourceKey].hasOwnProperty('data') || !target[sourceKey].hasOwnProperty('data')) {
          throw Error('Missing a data property in a relationship field');
        }

        if (Array.isArray(source[sourceKey].data) !== Array.isArray(target[sourceKey].data)) {
          throw Error('Mismatched schemas, multiple related entities applied to single entity relationship.');
        }

        if (Array.isArray(source[sourceKey].data)) {
          var relIds = new Set();

          var _iterator = _createForOfIteratorHelper(source[sourceKey].data),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var rel = _step.value;

              if (!rel.id) {
                continue;
              }

              relIds.add(rel.id);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var _iterator2 = _createForOfIteratorHelper(target[sourceKey].data),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _rel = _step2.value;

              if (!_rel.id) {
                continue;
              }

              if (!relIds.has(_rel.id)) {
                return false;
              }

              relIds.delete(_rel.id);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (relIds.size > 0) {
            return false;
          }
        } else if (source[sourceKey].data && source[sourceKey].data.id && target[sourceKey].data && target[sourceKey].data.id && source[sourceKey].data.id === target[sourceKey].data.id) {
          continue;
        } else {
          return false;
        }
      }

      if (Array.isArray(target[sourceKey]) && Array.isArray(source[sourceKey]) && target[sourceKey].length !== source[sourceKey].length) {
        return false;
      }

      if (!compareDeepMerge(target[sourceKey], source[sourceKey], sourceKey)) {
        return false;
      }
    } else if (!target.hasOwnProperty(sourceKey) || target[sourceKey] !== source[sourceKey]) {
      return false;
    }
  }

  return true;
}

var auth = new Auth();
var initialState = {
  auth: auth,
  userData: {},
  unsavedChanges: {},
  loading: false,
  initialLoadingComplete: false,
  currentUserId: null,
  requests: 0
};
var UserContext = React.createContext(initialState);

function uuidv4() {
  if (typeof crypto !== "undefined") {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
}

function generateLocalId() {
  return "local-".concat(uuidv4());
}

function changeEntityAction(state, action, save) {
  var updatedUserData = _objectSpread({}, state.userData);

  var entityUnchanged = applyChange(updatedUserData, action.data);

  if (entityUnchanged && save === 'cache') {
    return state;
  }

  if (save === 'nocache') {
    return _objectSpread(_objectSpread({}, state), {}, {
      userData: _objectSpread({}, updatedUserData)
    });
  }

  var updatedUnsavedChanges = _objectSpread({}, state.unsavedChanges);

  if (action.type === 'SUBMIT_ENTITY' && typeof action.validate === "function") {
    var errorArray = action.validate();

    var errorsChecked = function errorsChecked(state, errorArray, changedEntity) {
      var errorsOccurredArray = [];
      if (changedEntity && changedEntity.errors) delete changedEntity.errors;

      var _iterator3 = _createForOfIteratorHelper(errorArray),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var check = _step3.value;

          if (!changedEntity.attributes && updatedUserData[action.componentId] && updatedUserData[action.componentId].attributes && updatedUserData[action.componentId].attributes[check.field] && updatedUserData[action.componentId].attributes[check.field].value) {
            if (check.validFunc && !check.validFunc(updatedUserData[action.componentId].attributes[check.field].value)) {
              errorsOccurredArray.push({
                source: {
                  "pointer": "/data/attributes/".concat(check.field)
                },
                detail: check.invalidMessage
              });
            }
          } else {
            if (changedEntity.attributes && changedEntity.attributes[check.field]) {
              if (check.validFunc && !check.validFunc(changedEntity.attributes[check.field].value)) {
                errorsOccurredArray.push({
                  source: {
                    "pointer": "/data/attributes/".concat(check.field)
                  },
                  detail: check.invalidMessage
                });
              }
            } else if (!changedEntity.attributes || !changedEntity.attributes[check.field]) {
              errorsOccurredArray.push({
                source: {
                  "pointer": "/data/attributes/".concat(check.field)
                },
                detail: check.invalidMessage
              });
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return errorsOccurredArray;
    };

    if (errorArray.length && Object.keys(updatedUnsavedChanges).length) {
      Object.keys(updatedUnsavedChanges).map(function (id) {
        if (action.componentId == id || action.componentId == updatedUnsavedChanges[id].id) updatedUnsavedChanges[id].errors = errorsChecked(state, errorArray, updatedUnsavedChanges[id]);
      });
    } else if (errorArray.length && !Object.keys(updatedUnsavedChanges).length && action.componentId) {
      updatedUnsavedChanges[action.componentId] = {
        errors: errorsChecked(state, errorArray, {})
      };
    }
  }

  applyChange(updatedUnsavedChanges, _objectSpread(_objectSpread({}, action.data), {}, {
    save: save
  }));
  return _objectSpread(_objectSpread({}, state), {}, {
    unsavedChanges: _objectSpread(_objectSpread({}, state.unsavedChanges), updatedUnsavedChanges)
  });
}

function applyUnsavedChangesAction(state, action) {
  var updatedUserData = _objectSpread({}, state.userData);

  var id = action.id;

  if (!state.unsavedChanges[id]) {
    return state;
  }

  applyChange(updatedUserData, state.unsavedChanges[id]);
  return _objectSpread(_objectSpread({}, state), {}, {
    userData: _objectSpread(_objectSpread({}, state.userData), updatedUserData),
    unsavedChanges: _objectSpread(_objectSpread({}, state.unsavedChanges), {}, _defineProperty({}, id, {
      save: false
    }))
  });
}

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'startRequest':
      return _objectSpread(_objectSpread({}, state), {}, {
        requests: state.requests + 1
      });

    case 'endRequest':
      return _objectSpread(_objectSpread({}, state), {}, {
        requests: state.requests - 1
      });

    case 'loginUser':
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthenticated: true
      });

    case 'logoutUser':
      return _objectSpread(_objectSpread({}, state), {}, {
        userData: {},
        isAuthenticated: false,
        initialLoadingComplete: false
      });

    case 'beginLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });

    case 'completeLoading':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        initialLoadingComplete: true
      });

    case 'updateUserData':
      return _objectSpread(_objectSpread({}, state), {}, {
        userData: _objectSpread(_objectSpread({}, state.userData), action.payload.userData)
      });

    case 'CHANGE_ENTITY':
      return changeEntityAction(state, action, action.save);

    case 'SUBMIT_ENTITY':
      return changeEntityAction(state, action, action.componentId);

    case 'COMPLETE_SAVE_ENTITY':
      return applyUnsavedChangesAction(state, action);

    case 'CANCEL_ENTITY':
      return _objectSpread(_objectSpread({}, state), {}, {
        unsavedChanges: _objectSpread(_objectSpread({}, state.unsavedChanges), {}, _defineProperty({}, action.id, {
          save: false
        }))
      });

    case 'SET_CURRENT_USER_ENTITY':
      var changedState = changeEntityAction(state, action, 'nocache');
      return _objectSpread(_objectSpread({}, changedState), {}, {
        currentUserId: action.data.id
      });

    case 'updateBackendUserData':
      if (state.requests === 0) {
        return _objectSpread(_objectSpread({}, state), {}, {
          userData: _objectSpread(_objectSpread({}, state.userData), action.payload.userData)
        });
      } else {
        return state;
      }

    case 'invalidateUserData':
      return _objectSpread(_objectSpread({}, state), {}, {
        userData: {}
      });

    default:
      return state;
  }
};

function sync(_x11, _x12) {
  return _sync.apply(this, arguments);
}

function _sync() {
  _sync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(entityBody, dispatch) {
    var files,
        del,
        delayTimeoutState,
        delayTime,
        convertToEntityUri,
        updateBackend,
        _updateBackend,
        _delayTimeoutState,
        timeoutId,
        timeoutSetter,
        newTimeoutId,
        _args14 = arguments;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _updateBackend = function _updateBackend3() {
              _updateBackend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                var _i4, _Object$entries2, _Object$entries2$_i, field, rel, _iterator4, _step4, relEnt, requestQueueKey, entityType, entityUri, existingRequestQueue, appendFileUploadRequests, fetchedEntityObj, requestObj, requestQueue, _requestQueue, _requestObj, _iterator5, _step5, req, _requestQueue2, _delayTimeoutState2, _, _timeoutSetter;

                return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        appendFileUploadRequests = function _appendFileUploadRequ(files, requestQueue) {
                          var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                          if (files) {
                            var dummyBody = id ? {
                              data: {
                                id: id
                              }
                            } : {};

                            for (var _i5 = 0, _Object$entries3 = Object.entries(files); _i5 < _Object$entries3.length; _i5++) {
                              var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i5], 2),
                                  _field = _Object$entries3$_i[0],
                                  file = _Object$entries3$_i[1];

                              var fileKey = uuidv4();
                              set(fileKey, file);
                              requestQueue.push({
                                uri: entityUri,
                                method: 'POST',
                                fileKey: fileKey,
                                uriAfterId: _field,
                                body: dummyBody
                              });
                            }
                          }

                          return requestQueue;
                        };

                        entityBody = JSON.parse(JSON.stringify(entityBody));

                        if (!entityBody.data.relationships) {
                          _context13.next = 35;
                          break;
                        }

                        _i4 = 0, _Object$entries2 = Object.entries(entityBody.data.relationships);

                      case 4:
                        if (!(_i4 < _Object$entries2.length)) {
                          _context13.next = 35;
                          break;
                        }

                        _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2), field = _Object$entries2$_i[0], rel = _Object$entries2$_i[1];

                        if (!rel.data) {
                          _context13.next = 31;
                          break;
                        }

                        if (!Array.isArray(rel.data)) {
                          _context13.next = 28;
                          break;
                        }

                        _iterator4 = _createForOfIteratorHelper(rel.data);
                        _context13.prev = 9;

                        _iterator4.s();

                      case 11:
                        if ((_step4 = _iterator4.n()).done) {
                          _context13.next = 18;
                          break;
                        }

                        relEnt = _step4.value;

                        if (relEnt.id) {
                          _context13.next = 16;
                          break;
                        }

                        delete entityBody.data.relationships[field];
                        return _context13.abrupt("break", 18);

                      case 16:
                        _context13.next = 11;
                        break;

                      case 18:
                        _context13.next = 23;
                        break;

                      case 20:
                        _context13.prev = 20;
                        _context13.t0 = _context13["catch"](9);

                        _iterator4.e(_context13.t0);

                      case 23:
                        _context13.prev = 23;

                        _iterator4.f();

                        return _context13.finish(23);

                      case 26:
                        _context13.next = 29;
                        break;

                      case 28:
                        if (!rel.data.id) {
                          delete entityBody.data.relationships[field];
                        }

                      case 29:
                        _context13.next = 32;
                        break;

                      case 31:
                        delete entityBody.data.relationships[field];

                      case 32:
                        _i4++;
                        _context13.next = 4;
                        break;

                      case 35:
                        requestQueueKey = entityBody.data.id ? "request:".concat(entityBody.data.id) : "request:".concat(entityBody.data.local_id);
                        entityType = entityBody.data.type;
                        entityUri = convertToEntityUri(entityType);
                        existingRequestQueue = typeof window !== "undefined" ? localStorage.getItem(requestQueueKey) : [];

                        if (!del) {
                          _context13.next = 52;
                          break;
                        }

                        requestObj = {
                          body: entityBody,
                          method: 'DELETE',
                          uri: entityUri
                        };

                        if (!existingRequestQueue) {
                          _context13.next = 46;
                          break;
                        }

                        existingRequestQueue = JSON.parse(existingRequestQueue);

                        if (existingRequestQueue.length === 0) {
                          existingRequestQueue.push(requestObj);
                        } else {
                          if (compareDeepMerge(existingRequestQueue[0].body, entityBody)) {
                            requestObj.body = mergeDeep(existingRequestQueue[0].body, entityBody);
                          }

                          existingRequestQueue = [requestObj];
                        }

                        if (typeof window !== "undefined") {
                          localStorage.setItem(requestQueueKey, JSON.stringify(existingRequestQueue));
                        }

                        return _context13.abrupt("return");

                      case 46:
                        requestQueue = [requestObj];
                        _context13.next = 49;
                        return handleQueue(auth, dispatch, requestQueue, requestQueueKey);

                      case 49:
                        fetchedEntityObj = _context13.sent;
                        _context13.next = 93;
                        break;

                      case 52:
                        if (!(!existingRequestQueue && !entityBody.data.id)) {
                          _context13.next = 60;
                          break;
                        }

                        _requestQueue = [{
                          uri: entityUri,
                          method: 'POST',
                          body: entityBody
                        }];
                        appendFileUploadRequests(files, _requestQueue);
                        _context13.next = 57;
                        return handleQueue(auth, dispatch, _requestQueue, requestQueueKey);

                      case 57:
                        fetchedEntityObj = _context13.sent;
                        _context13.next = 93;
                        break;

                      case 60:
                        _requestObj = {
                          body: entityBody,
                          method: 'PATCH',
                          uri: entityUri
                        };

                        if (!existingRequestQueue) {
                          _context13.next = 88;
                          break;
                        }

                        existingRequestQueue = JSON.parse(existingRequestQueue);

                        if (!(existingRequestQueue.length === 0)) {
                          _context13.next = 67;
                          break;
                        }

                        existingRequestQueue.push(_requestObj);
                        _context13.next = 85;
                        break;

                      case 67:
                        _iterator5 = _createForOfIteratorHelper(existingRequestQueue);
                        _context13.prev = 68;

                        _iterator5.s();

                      case 70:
                        if ((_step5 = _iterator5.n()).done) {
                          _context13.next = 77;
                          break;
                        }

                        req = _step5.value;

                        if (!(!req.fileKey && compareDeepMerge(req.body, entityBody))) {
                          _context13.next = 75;
                          break;
                        }

                        req.body = mergeDeep(req.body, entityBody);
                        return _context13.abrupt("break", 77);

                      case 75:
                        _context13.next = 70;
                        break;

                      case 77:
                        _context13.next = 82;
                        break;

                      case 79:
                        _context13.prev = 79;
                        _context13.t1 = _context13["catch"](68);

                        _iterator5.e(_context13.t1);

                      case 82:
                        _context13.prev = 82;

                        _iterator5.f();

                        return _context13.finish(82);

                      case 85:
                        appendFileUploadRequests(files, existingRequestQueue, entityBody.data.id);

                        if (typeof window !== "undefined") {
                          localStorage.setItem(requestQueueKey, JSON.stringify(existingRequestQueue));
                        }

                        return _context13.abrupt("return");

                      case 88:
                        _requestQueue2 = [_requestObj];
                        appendFileUploadRequests(files, _requestQueue2, entityBody.data.id);
                        _context13.next = 92;
                        return handleQueue(auth, dispatch, _requestQueue2, requestQueueKey);

                      case 92:
                        fetchedEntityObj = _context13.sent;

                      case 93:
                        dispatch({
                          type: 'endRequest'
                        });

                        if (delayTimeoutState) {
                          _delayTimeoutState2 = _slicedToArray(delayTimeoutState, 2), _ = _delayTimeoutState2[0], _timeoutSetter = _delayTimeoutState2[1];

                          _timeoutSetter(null);
                        }

                      case 95:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13, null, [[9, 20, 23, 26], [68, 79, 82, 85]]);
              }));
              return _updateBackend.apply(this, arguments);
            };

            updateBackend = function _updateBackend2() {
              return _updateBackend.apply(this, arguments);
            };

            convertToEntityUri = function _convertToEntityUri(entityType) {
              var splitType = entityType.split('--');

              if (splitType.length !== 2) {
                throw Error('Entity type not formatted as "entity_type--bundle_type". Could not infer type information');
              }

              var _splitType = _slicedToArray(splitType, 2),
                  type = _splitType[0],
                  bundle = _splitType[1];

              return "".concat(type, "/").concat(bundle);
            };

            files = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : false;
            del = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : false;
            delayTimeoutState = _args14.length > 4 && _args14[4] !== undefined ? _args14[4] : false;
            delayTime = _args14.length > 5 && _args14[5] !== undefined ? _args14[5] : 1;

            if (!delayTimeoutState) {
              _context14.next = 15;
              break;
            }

            _delayTimeoutState = _slicedToArray(delayTimeoutState, 2), timeoutId = _delayTimeoutState[0], timeoutSetter = _delayTimeoutState[1];

            if (!timeoutId) {
              dispatch({
                type: 'startRequest'
              });
            }

            clearTimeout(timeoutId);
            newTimeoutId = setTimeout(updateBackend.bind(this), delayTime);
            timeoutSetter(newTimeoutId);
            _context14.next = 17;
            break;

          case 15:
            _context14.next = 17;
            return updateBackend.call(this);

          case 17:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));
  return _sync.apply(this, arguments);
}

function handleLogin(_x13, _x14) {
  return _handleLogin2.apply(this, arguments);
}

function _handleLogin2() {
  _handleLogin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(userContext, ev) {
    var _userContext5, userState, dispatch, auth, token;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _userContext5 = _slicedToArray(userContext, 2), userState = _userContext5[0], dispatch = _userContext5[1];
            auth = userState.auth;
            _context15.next = 4;
            return auth.handleLogin(ev, dispatch);

          case 4:
            token = _context15.sent;

            if (!(token && token.token)) {
              _context15.next = 9;
              break;
            }

            dispatch({
              type: 'loginUser',
              payload: {
                auth: auth
              }
            });
            _context15.next = 10;
            break;

          case 9:
            return _context15.abrupt("return", false);

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _handleLogin2.apply(this, arguments);
}

function submitLogin(_x15, _x16) {
  return _submitLogin.apply(this, arguments);
}

function _submitLogin() {
  _submitLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(userContext, formData) {
    var _userContext6, userState, dispatch, auth, token;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _userContext6 = _slicedToArray(userContext, 2), userState = _userContext6[0], dispatch = _userContext6[1];
            auth = userState.auth;
            _context16.next = 4;
            return auth.loginUser(formData, dispatch, 'authorization_code');

          case 4:
            token = _context16.sent;

            if (!(token && token.token)) {
              _context16.next = 9;
              break;
            }

            dispatch({
              type: 'loginUser',
              payload: {
                auth: auth
              }
            });
            _context16.next = 10;
            break;

          case 9:
            return _context16.abrupt("return", false);

          case 10:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _submitLogin.apply(this, arguments);
}

function handleLogout(userContext, ev) {
  var _userContext = _slicedToArray(userContext, 2),
      userState = _userContext[0],
      dispatch = _userContext[1];

  var auth = userState.auth;
  var loggedOut = auth.logoutUser(ev);

  if (loggedOut) {
    dispatch({
      type: 'logoutUser',
      payload: {
        auth: auth
      }
    });
  }

  return loggedOut;
}

function isLoggedIn(userContext) {
  var userState = userContext[0];
  var auth = userState.auth;
  return auth.isLoggedIn();
}

function applyChange(userData, entityChange) {
  var idOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var del = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var entityId = entityChange.id ? entityChange.id : entityChange.local_id;

  if (del) {
    if (userData[entityId]) {
      delete userData[entityId];
      return false;
    }

    return true;
  }

  if (entityChange.id && entityChange.id === entityChange.local_id) {
    delete entityChange.id;
  } else if (entityChange.id && entityChange.local_id && userData[entityChange.local_id]) {
    userData[entityChange.id] = userData[entityChange.local_id];
    delete userData[entityChange.local_id];
  }

  if (!userData.hasOwnProperty(entityId)) {
    userData[entityId] = {};
  }

  var dataNotChanged = compareDeepMerge(userData[entityId], entityChange);

  if (idOnly) {
    entityChange = entityChange.local_id ? {
      id: entityChange.id,
      local_id: entityChange.local_id
    } : {
      id: entityChange.id
    };
  }

  if (!dataNotChanged && entityChange.relationships) {
    for (var relationship in entityChange.relationships) {
      if (typeof window !== "undefined" && entityChange.relationships[relationship].data && entityChange.relationships[relationship].data.file && entityChange.relationships[relationship].data.file instanceof File) {
        var objUrl = window.URL.createObjectURL(entityChange.relationships[relationship].data.file);
        entityChange.relationships[relationship].data.file = objUrl;
      }
    }
  }

  var mergedData = mergeDeep(userData[entityId], entityChange);
  userData[entityId] = mergedData;
  return dataNotChanged;
}

function handleQueue(_x17, _x18, _x19, _x20) {
  return _handleQueue.apply(this, arguments);
}

function _handleQueue() {
  _handleQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(auth, dispatch, requestQueue, requestQueueKey) {
    var getStrippedBody, id, fetchedEntityObj, localId, req, uri, method, body, response, toFile, file, fileObj, local;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            getStrippedBody = function _getStrippedBody(unstrippedBody) {
              var strippedBody = {};

              if (unstrippedBody.data) {
                var data = unstrippedBody.data,
                    restOfStrippedBody = _objectWithoutProperties(unstrippedBody, _excluded2);

                strippedBody = _objectSpread({}, restOfStrippedBody);

                if (data.attributes) {
                  var _data$attributes = data.attributes,
                      created = _data$attributes.created,
                      changed = _data$attributes.changed,
                      strippedAttrs = _objectWithoutProperties(_data$attributes, _excluded3),
                      strippedData = _objectWithoutProperties(data, _excluded4);

                  strippedBody.data = _objectSpread(_objectSpread({}, strippedData), {}, {
                    attributes: _objectSpread({}, strippedAttrs)
                  });
                }

                if (data.relationships) {
                  var _ref5 = strippedBody.data ? strippedBody.data : data,
                      _ref5$relationships = _ref5.relationships,
                      uid = _ref5$relationships.uid,
                      strippedRels = _objectWithoutProperties(_ref5$relationships, _excluded5),
                      _strippedData = _objectWithoutProperties(_ref5, _excluded6);

                  strippedBody.data = _objectSpread(_objectSpread({}, _strippedData), {}, {
                    relationships: _objectSpread({}, strippedRels)
                  });
                } else {
                  strippedBody.data = data;
                }
              }

              return strippedBody;
            };

            id = "";
            localId = false;

          case 3:
            if (!(requestQueue.length > 0)) {
              _context17.next = 56;
              break;
            }

            req = requestQueue.shift();
            uri = req.uri, method = req.method, body = req.body;

            if (!localId && body && body.data && body.data.local_id) {
              localId = body.data.local_id;
            }

            if (body && body.data && body.data.hasOwnProperty('id')) {
              id = body.data.id;
            } else if (id !== "" && !req.hasOwnProperty('uriAfterId')) {
              if (!body.data) {
                body.data = {};
              }

              body.data.id = id;
            }

            uri = req.hasOwnProperty('uriAfterId') ? "".concat(uri, "/").concat(id, "/").concat(req.uriAfterId) : "".concat(uri, "/").concat(id);

            if (typeof window !== "undefined") {
              localStorage.setItem(requestQueueKey, JSON.stringify(requestQueue));
            }

            response = void 0;

            if (!req.fileKey) {
              _context17.next = 28;
              break;
            }

            toFile = function toFile(file) {
              var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
              return new Promise(function (resolve, reject) {
                var reader = new FileReader();

                try {
                  try {
                    reader.readAsArrayBuffer(file);
                    return resolve(file);
                  } catch (e) {
                    fetch(file).then(function (fetchedFile) {
                      fetchedFile.blob().then(function (blobFile) {
                        return resolve(new File([blobFile], name));
                      });
                    });
                  }
                } catch (e) {
                  return reject('file unprocessed');
                }
              });
            };

            _context17.next = 15;
            return get(req.fileKey);

          case 15:
            file = _context17.sent;

            if (file) {
              _context17.next = 18;
              break;
            }

            return _context17.abrupt("continue", 3);

          case 18:
            _context17.next = 20;
            return toFile(file.data, file.name);

          case 20:
            fileObj = _context17.sent;
            _context17.next = 23;
            return fetchAuthenticatedContent(auth, dispatch, uri, method, fileObj, {
              'Accept': 'application/vnd.api+json',
              'Content-Type': 'application/octet-stream',
              'Content-Disposition': "file; filename=\"".concat(file.name, "\"")
            });

          case 23:
            response = _context17.sent;
            _context17.next = 26;
            return del(req.fileKey);

          case 26:
            _context17.next = 37;
            break;

          case 28:
            if (!(method === 'DELETE')) {
              _context17.next = 34;
              break;
            }

            _context17.next = 31;
            return fetchAuthenticatedContent(auth, dispatch, uri, method);

          case 31:
            response = _context17.sent;
            _context17.next = 37;
            break;

          case 34:
            _context17.next = 36;
            return fetchAuthenticatedContent(auth, dispatch, uri, method, getStrippedBody(body));

          case 36:
            response = _context17.sent;

          case 37:
            if (!checkIfDuplicateModification(response)) {
              _context17.next = 39;
              break;
            }

            return _context17.abrupt("return", typeof fetchedEntityObj === 'undefined' ? false : fetchedEntityObj);

          case 39:
            if (!(method === 'DELETE')) {
              _context17.next = 41;
              break;
            }

            return _context17.abrupt("break", 56);

          case 41:
            if (!response.hasOwnProperty('data')) {
              _context17.next = 50;
              break;
            }

            fetchedEntityObj = response;

            if (localId) {
              response.data.local_id = localId;
            }

            local = getLocal();
            local[response.data.id] = response.data;
            delete local[localId];
            saveLocal(local);
            _context17.next = 50;
            return dispatch({
              type: 'CHANGE_ENTITY',
              data: response.data,
              save: 'nocache'
            });

          case 50:
            if (response.hasOwnProperty('data') && response.data.hasOwnProperty('id')) {
              id = response.data.id;
            }

            requestQueue = typeof window !== "undefined" ? JSON.parse(localStorage.getItem(requestQueueKey)) : null;

            if (!(requestQueue === null)) {
              _context17.next = 54;
              break;
            }

            return _context17.abrupt("return", fetchedEntityObj);

          case 54:
            _context17.next = 3;
            break;

          case 56:
            if (typeof window !== "undefined") {
              localStorage.removeItem(requestQueueKey);
            }

            return _context17.abrupt("return", fetchedEntityObj);

          case 58:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _handleQueue.apply(this, arguments);
}

function fetchAuthenticatedContent(_x21, _x22, _x23) {
  return _fetchAuthenticatedContent.apply(this, arguments);
}

function _fetchAuthenticatedContent() {
  _fetchAuthenticatedContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(auth, dispatch, jsonapi_endpoint) {
    var method,
        body,
        headers,
        content,
        _args18 = arguments;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            method = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : 'GET';
            body = _args18.length > 4 && _args18[4] !== undefined ? _args18[4] : null;
            headers = _args18.length > 5 && _args18[5] !== undefined ? _args18[5] : null;
            _context18.next = 5;
            return auth.drupalFetch(jsonapi_endpoint, method, body, headers);

          case 5:
            content = _context18.sent;

            if (!content) {
              dispatch({
                type: 'logoutUser',
                payload: {
                  auth: auth
                }
              });
            }

            return _context18.abrupt("return", content);

          case 8:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _fetchAuthenticatedContent.apply(this, arguments);
}

var initializeLoginState = function initializeLoginState(auth, dispatch, refreshedToken) {
  if (refreshedToken) {
    dispatch({
      type: 'loginUser',
      payload: {
        auth: auth
      }
    });
  } else {
    dispatch({
      type: 'logoutUser',
      payload: {
        auth: auth
      }
    });
  }
};

var UserContextProvider = function UserContextProvider(props) {
  var _React$useReducer = React.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var logoutFunc = handleLogout.bind(null, auth, dispatch);

  function runInitialLoading(_x24) {
    return _runInitialLoading.apply(this, arguments);
  }

  function _runInitialLoading() {
    _runInitialLoading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(userData) {
      var currentUser, data, key, requestQueue, ret;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dispatch({
                type: 'beginLoading'
              });
              currentUser = getLocalCurrentUser();

              if (currentUser) {
                data = getLocalEntity({
                  id: currentUser
                });

                if (data) {
                  dispatch({
                    type: "SET_CURRENT_USER_ENTITY",
                    data: data
                  });
                }
              }

              if (!(typeof window !== "undefined")) {
                _context10.next = 14;
                break;
              }

              _context10.t0 = _regeneratorRuntime.keys(localStorage);

            case 5:
              if ((_context10.t1 = _context10.t0()).done) {
                _context10.next = 14;
                break;
              }

              key = _context10.t1.value;

              if (!key.startsWith('request:')) {
                _context10.next = 12;
                break;
              }

              requestQueue = JSON.parse(localStorage.getItem(key));
              _context10.next = 11;
              return handleQueue(auth, dispatch, requestQueue, key);

            case 11:
              ret = _context10.sent;

            case 12:
              _context10.next = 5;
              break;

            case 14:
              dispatch({
                type: 'completeLoading'
              });

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _runInitialLoading.apply(this, arguments);
  }

  var existingUserData = {};

  if (typeof window !== "undefined" && localStorage.getItem("entitysync_user_data") !== null && Object.keys(state.userData).length === 0) {
    existingUserData = JSON.parse(localStorage.getItem("entitysync_user_data"));
    dispatch({
      type: 'updateUserData',
      payload: {
        userData: existingUserData
      }
    });
  }

  useEffect(function () {
    if (!state.hasOwnProperty('isAuthenticated')) {
      var initLogin = initializeLoginState.bind(null, auth, dispatch);
      initLogin();
    }
  }, [state.isAuthenticated]);
  useEffect(function () {
    runInitialLoading();
  }, [state.isAuthenticated]);

  var user = _objectSpread({}, state);

  if (props.saveLocal) {
    user.saveLocal = props.saveLocal;
  }

  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: [_objectSpread({}, user), dispatch]
  }, props.children);
};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

function getPropTypeError(type, propName, componentName) {
  return new Error('Non-' + type + ' prop ' + propName + ' supplied to' + ' `' + componentName + '`. Validation failed.');
}

function createPropType(type, validator) {
  function propType(props, propName, componentName) {
    if (!validator(props[propName])) {
      return getPropTypeError(type, propName, componentName);
    }
  }

  try {
    Object.defineProperty(propType, 'name', {
      value: type
    });
  } catch (e) {// https://github.com/benwiley4000/react-extra-prop-types/issues/1
  }

  function optional(props, propName, componentName) {
    var prop = props[propName];

    if (prop === null || prop === void 0) {
      return;
    }

    return propType(props, propName, componentName);
  }

  optional.isRequired = propType;
  return optional;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
function isInteger(prop) {
  return typeof prop === 'number' && isFinite(prop) && Math.floor(prop) === prop;
}

// http://stackoverflow.com/a/32685393
function isColor(prop) {
  return (// hex
    /^#(?:[A-Fa-f0-9]{3}){1,2}$/i.test(prop) || // rgb
    /^rgb[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*(?:,(?![)])|(?=[)]))){3}[)]$/i.test(prop) || // rgba
    /^^rgba[(](?:\s*0*(?:\d\d?(?:\.\d+)?(?:\s*%)?|\.\d+\s*%|100(?:\.0*)?\s*%|(?:1\d\d|2[0-4]\d|25[0-5])(?:\.\d+)?)\s*,){3}\s*0*(?:\.\d+|1(?:\.0*)?)\s*[)]$/i.test(prop) || // hsl
    /^hsl[(]\s*0*(?:[12]?\d{1,2}|3(?:[0-5]\d|60))\s*(?:\s*,\s*0*(?:\d\d?(?:\.\d+)?\s*%|\.\d+\s*%|100(?:\.0*)?\s*%)){2}\s*[)]$/i.test(prop) || // hsla
    /^hsla[(]\s*0*(?:[12]?\d{1,2}|3(?:[0-5]\d|60))\s*(?:\s*,\s*0*(?:\d\d?(?:\.\d+)?\s*%|\.\d+\s*%|100(?:\.0*)?\s*%)){2}\s*,\s*0*(?:\.\d+|1(?:\.0*)?)\s*[)]$/i.test(prop)
  );
}

function isDatetime(prop) {
  return typeof prop === 'string' && !isNaN(new Date(prop).getTime());
}

// http://stackoverflow.com/a/13653180
function isUuid(prop) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(prop);
}

var EntityContext = createContext({});
var SubmitContext = createContext([{}, function (_) {
  return void 0;
}]);
var RelationshipContext = createContext(undefined);

function connect(mapStateToProps, mapDispatchToProps) {
  return function (Component) {
    return function (props) {
      var userContext = useContext(UserContext);
      var entityContext = useContext(EntityContext);
      var relContext = useContext(RelationshipContext);

      if (!Array.isArray(userContext) || userContext.length !== 2) {
        return React.createElement(Fragment$1, null);
      }

      var _userContext2 = _slicedToArray(userContext, 2),
          state = _userContext2[0],
          dispatch = _userContext2[1];

      var entity = entityContext.data ? entityContext.data : undefined;
      var stateToProps = mapStateToProps(state, _objectSpread(_objectSpread({}, props), {}, {
        entity: entity
      }));
      var dispatchToProps = mapDispatchToProps(dispatch, _objectSpread(_objectSpread({}, props), {}, {
        entity: entity,
        entityProps: entityContext.props ? entityContext.props : undefined,
        relationship: relContext
      }));
      props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), stateToProps), dispatchToProps), {}, {
        entity: entity
      });
      return React.createElement(Component, Object.assign({}, props));
    };
  };
}

function mapStateToProps(state, ownProps) {
  if (ownProps.entity && ownProps.entity.id) {
    return {
      entity: state.userData[ownProps.entity.id]
    };
  } else {
    return {
      entity: null
    };
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    changeEntity: function changeEntity(payload) {
      return _changeEntity(payload, dispatch, ownProps);
    }
  };
}

function _changeEntity(change, dispatch, ownProps) {
  var entity = ownProps.entity;
  var save = !!(ownProps.entityProps && ownProps.entityProps.autosave) ? ownProps.entityProps.componentId : 'cache';

  if (entity && entity.id) {
    change.id = entity.id;
  }

  if (entity && entity.local_id) {
    change.local_id = entity.local_id;
  }

  if (entity && entity.type) {
    change.type = entity.type;
  }

  dispatch({
    type: 'CHANGE_ENTITY',
    data: change,
    save: save
  });

  if (ownProps.relationship && (!ownProps.entityProps || ownProps.entityProps && ownProps.entityProps.autoAttach)) {
    attachEntityToRel(change, ownProps.relationship);
  }
}

function attachEntityToRel(_x25, _x26) {
  return _attachEntityToRel.apply(this, arguments);
}

function _attachEntityToRel() {
  _attachEntityToRel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(entity, relContext) {
    var _relContext, relObj, setRel, rel, relSet;

    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            if (Array.isArray(relContext) && relContext.length === 2) {
              _relContext = _slicedToArray(relContext, 2), relObj = _relContext[0], setRel = _relContext[1];
              rel = relObj.relationships[Object.keys(relObj.relationships)[0]].data;

              if (Array.isArray(rel)) {
                relSet = new Set(rel.map(function (entity) {
                  return entity.id ? entity.id : entity.local_id;
                }));

                if (entity.id && !relSet.has(entity.id)) {
                  setRel(rel.concat({
                    id: entity.id,
                    type: entity.type
                  }));
                } else if (entity.local_id && !relSet.has(entity.local_id)) {
                  setRel(rel.concat({
                    local_id: entity.local_id,
                    type: entity.type
                  }));
                }
              } else if (rel) {
                if (entity.id && entity.id !== rel.id) {
                  setRel({
                    id: entity.id,
                    type: entity.type
                  });
                } else if (entity.local_id && entity.local_id !== rel.local_id) {
                  setRel({
                    local_id: entity.local_id,
                    type: entity.type
                  });
                }
              }
            }

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _attachEntityToRel.apply(this, arguments);
}

function isDataSource(source) {
  return typeof source === 'object' && !Array.isArray(source);
}

function isSingleRelationshipIdentifier(relData) {
  return !Array.isArray(relData);
}

function Entity(props) {
  var type = props.type,
      source = props.source,
      children = props.children,
      componentId = props.componentId,
      validate = props.validate;
  var userContext = useContext(UserContext);
  var relContext = useContext(RelationshipContext);

  if (!Array.isArray(userContext) || userContext.length !== 2) {
    return React.createElement(Fragment$1, null);
  }

  var _userContext3 = _slicedToArray(userContext, 2),
      state = _userContext3[0],
      dispatch = _userContext3[1];

  if (source && source.id === '1804749b-5bcb-4504-97d0-395319fbb92b') {
    console.log(state);
  }

  var entityId, sourceObj;
  var initialLocalId = generateLocalId();

  if (isDataSource(source)) {
    sourceObj = source;

    if (sourceObj.local_id) {
      initialLocalId = sourceObj.local_id;
    }
  } else if (Array.isArray(source) && source.length == 2) {
    var _source = _slicedToArray(source, 2),
        sourceState = _source[0],
        setSource = _source[1];

    sourceObj = sourceState;

    if (!sourceObj.local_id) {
      sourceObj.local_id = initialLocalId;
      setSource(sourceObj);
    }
  } else if (source) {
    sourceObj = {
      id: source
    };
  } else if (Array.isArray(relContext) && relContext.length === 2 && (relContext[0].id || relContext[0].local_id)) {
    sourceObj = relContext[0];
  } else {
    sourceObj = {};
  }

  var _useState = useState(source && source.id ? source.id : componentId ? componentId : generateLocalId()),
      _useState2 = _slicedToArray(_useState, 1),
      componentLocalId = _useState2[0];

  var _useState3 = useState(initialLocalId),
      _useState4 = _slicedToArray(_useState3, 2),
      localId = _useState4[0],
      setLocalId = _useState4[1];

  var clearSource = setLocalId.bind(null, generateLocalId());

  if (Array.isArray(source) && source.length == 2) {
    clearSource = source[1].bind(null, {});

    if (sourceObj.local_id) {
      localId = sourceObj.local_id;
    }
  }

  useEffect(function () {
    if (!sourceObj.local_id) {
      sourceObj.local_id = localId;
    }

    dispatch({
      type: 'CHANGE_ENTITY',
      data: _objectSpread(_objectSpread({}, sourceObj), {}, {
        id: sourceObj.id,
        local_id: sourceObj.local_id
      }),
      save: 'nocache'
    });
  }, [localId]);

  if (!sourceObj.type) {
    sourceObj.type = type;
  }

  if (sourceObj.id) {
    entityId = sourceObj.id;
  } else if (sourceObj.local_id) {
    entityId = sourceObj.local_id;
  } else {
    entityId = localId;
    sourceObj.local_id = entityId;
  }

  var localStoredEntity = getLocalEntity(sourceObj);
  var entity;

  if (state.userData[entityId]) {
    entity = state.userData[entityId];
  } else if (localStoredEntity) {
    entity = localStoredEntity;
  } else {
    entity = sourceObj;
  }

  var usePrevious = function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };

  var prevId = usePrevious(sourceObj.local_id);
  var saveId = prevId === sourceObj.local_id ? entityId : prevId;
  var unsavedChange = state.unsavedChanges[saveId ? saveId : entityId];

  var updatedUserData = _objectSpread(_objectSpread({}, state.userData), {}, _defineProperty({}, entityId, entity));

  if (unsavedChange && (unsavedChange.id || unsavedChange.local_id)) {
    applyChange(updatedUserData, _objectSpread(_objectSpread({}, unsavedChange), {}, {
      id: unsavedChange.id,
      local_id: unsavedChange.local_id
    }));
  }

  entity = updatedUserData[entityId];
  var areErrors = unsavedChange && unsavedChange.errors && unsavedChange.errors.length;
  var shouldSave = unsavedChange && unsavedChange.save && unsavedChange.save === componentLocalId && !areErrors;
  useEffect(function () {
    if (shouldSave) {
      delete unsavedChange.save;
      var files = {};

      if (state.saveLocal) {
        state.saveLocal(updatedUserData);
      } else {
        saveLocal(updatedUserData);
      }

      if (unsavedChange && unsavedChange.relationships) {
        for (var relationship in unsavedChange.relationships) {
          if (unsavedChange.relationships[relationship].data) {
            var relData = unsavedChange.relationships[relationship].data;

            if (isSingleRelationshipIdentifier(relData) && relData.file) {
              files[relationship] = {
                data: relData.file,
                name: relData.attributes.filename
              };
              delete relData.file;
            }
          }
        }
      }

      if (Object.entries(files).length) {
        sync({
          data: unsavedChange
        }, dispatch, files);
      } else {
        sync({
          data: unsavedChange
        }, dispatch);
      }

      dispatch({
        type: 'COMPLETE_SAVE_ENTITY',
        id: entityId
      });
    }
  }, [shouldSave]);

  var submitFunc = function submitFunc() {
    var submitUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    dispatch({
      type: 'SUBMIT_ENTITY',
      data: submitUpdate,
      componentId: componentLocalId,
      validate: validate
    });
  };

  if (source && source.id === '1804749b-5bcb-4504-97d0-395319fbb92b') {
    console.log(state);
  }

  var emptySubmitChange = {
    attributes: {},
    relationships: {}
  };
  if (entity.local_id) emptySubmitChange.local_id = entity.local_id;
  if (entity.id) emptySubmitChange.id = entity.id;
  if (entity.type) emptySubmitChange.type = entity.type;
  return React.createElement(EntityContext.Provider, {
    value: {
      unsavedChange: unsavedChange,
      data: entity,
      props: _objectSpread(_objectSpread({}, props), {}, {
        componentId: componentLocalId
      }),
      clearSource: clearSource,
      cancel: function cancel() {
        return dispatch({
          type: 'CANCEL_ENTITY',
          id: entityId
        });
      }
    }
  }, React.createElement(SubmitContext.Provider, {
    value: [unsavedChange ? unsavedChange : emptySubmitChange, submitFunc]
  }, children));
}

function getAttrValueChange(field, value) {
  var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (entity == null) {
    entity = {};
  }

  if (!entity.attributes) {
    entity.attributes = {};
  }

  entity.attributes[field] = value;
  return entity;
}

function setRelData(field, data) {
  var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (entity == null) {
    entity = {};
  }

  if (!entity.relationships) {
    entity.relationships = {};
  }

  if (!entity.relationships[field]) {
    entity.relationships[field] = {
      data: data
    };
  }

  entity.relationships[field].data = data;
  return entity;
}

function getRelChange(field, defaultData, rel) {
  var data = rel.relationships && rel.relationships[field] && rel.relationships[field].data ? rel.relationships[field].data : defaultData;
  var change = {
    relationships: _defineProperty({}, field, {
      data: data
    })
  };

  if (rel.id) {
    change.id = rel.id;
  }

  if (rel.local_id) {
    change.local_id = rel.local_id;
  }

  if (rel.type) {
    change.type = rel.type;
  }

  return change;
}

function SubmitButtonComponent(Button) {
  return function SubmitButton(props) {
    var onSubmit = props.onSubmit,
        clear = props.clear,
        children = props.children;
    var submitContext = useContext(SubmitContext);
    var relationshipContext = useContext(RelationshipContext);
    var entityContext = useContext(EntityContext);

    if (!submitContext) {
      return React.createElement(Button, Object.assign({}, props), children);
    }

    var userContext = useContext(UserContext);

    if (!Array.isArray(userContext)) {
      return React.createElement(Fragment$1, null);
    }

    var _userContext4 = _slicedToArray(userContext, 1),
        currentUserId = _userContext4[0].currentUserId;

    var _submitContext = _slicedToArray(submitContext, 2),
        unsavedChange = _submitContext[0],
        submitUnsavedChange = _submitContext[1];

    function submit(_x27) {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(unsavedChange) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (entityContext.data) {
                  attachEntityToRel(entityContext.data, relationshipContext);
                }

                if (unsavedChange && !unsavedChange.attributes) {
                  unsavedChange.attributes = {};
                }

                if (unsavedChange && unsavedChange.attributes) {
                  unsavedChange.attributes.changed = Math.round(new Date().getTime() / 1000);

                  if (!(entityContext && entityContext.data && entityContext.data.attributes && entityContext.data.attributes.created)) {
                    unsavedChange.attributes.created = Math.round(new Date().getTime() / 1000);
                  }
                }

                if (unsavedChange && !unsavedChange.relationships && currentUserId) {
                  unsavedChange.relationships = {};
                }

                if (unsavedChange && unsavedChange.relationships && currentUserId && !unsavedChange.relationships.uid) {
                  unsavedChange.relationships.uid = {
                    data: {
                      id: currentUserId,
                      type: "user--user"
                    }
                  };
                }

                if (entityContext.data && entityContext.data.type) {
                  unsavedChange.type = entityContext.data.type;
                }

                if (entityContext.data && entityContext.data.local_id) {
                  unsavedChange.local_id = entityContext.data.local_id;
                }

                if (entityContext.data && entityContext.data.id) {
                  unsavedChange.id = entityContext.data.id;
                }

                submitUnsavedChange(unsavedChange);

                if (clear && entityContext.clearSource) {
                  entityContext.clearSource();
                }

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
      return _submit.apply(this, arguments);
    }

    var onClickFunc = onSubmit ? /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return onSubmit(e, unsavedChange, entityContext.data);

              case 2:
                if (!e.defaultPrevented) {
                  submit(unsavedChange);
                }

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x28) {
        return _ref2.apply(this, arguments);
      };
    }() : function () {
      return submit(unsavedChange);
    };
    return React.createElement(Button, Object.assign({}, props, {
      onClick: onClickFunc
    }), children);
  };
}

var FieldContext = createContext(null);
var Field = connect(mapStateToProps, mapDispatchToProps)(function (_ref3) {
  var field = _ref3.field,
      entity = _ref3.entity,
      changeEntity = _ref3.changeEntity,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded);

  if (!entity || !changeEntity || !field) {
    return React.createElement(React.Fragment, null);
  }

  function changeField(value) {
    if (changeEntity && field) {
      var change = props.getAttrValueChange ? props.getAttrValueChange(field, value) : getAttrValueChange(field, value);
      changeEntity(change);
    }
  }

  return React.createElement(EntityContext.Consumer, null, function (value) {
    var valueEntity = entity.attributes && entity.attributes[field] ? entity.attributes[field] : null;

    if (value.unsavedChange && value.unsavedChange.errors && value.unsavedChange.errors.length) {
      var errorIndex = value.unsavedChange.errors.findIndex(function (error) {
        return error.source["pointer"].includes(field);
      });
      var error = value.unsavedChange.errors[errorIndex];
      valueEntity.error = error;
    } else if (value.unsavedChange && value.unsavedChange.errors && !value.unsavedChange.errors.length && valueEntity && valueEntity.error) {
      delete valueEntity.error;
    }

    return React.createElement(FieldContext.Provider, {
      value: [valueEntity, changeField]
    }, React.createElement(React.Fragment, null, valueEntity && valueEntity.error ? React.createElement("div", {
      className: "error-detail"
    }, "*", valueEntity.error.detail) : React.createElement("span", {
      className: "error-detail"
    })), children);
  });
});
var Relationship = connect(mapStateToProps, mapDispatchToProps)(function (_ref4) {
  var field = _ref4.field,
      entity = _ref4.entity,
      changeEntity = _ref4.changeEntity,
      children = _ref4.children,
      multiValue = _ref4.multiValue;

  if (!entity || !changeEntity || !field) {
    return React.createElement(React.Fragment, null);
  }

  var initialValue = multiValue ? [] : null;
  var relChange = getRelChange(field, initialValue, _objectSpread(_objectSpread({}, entity), {}, {
    relationships: entity.relationships ? entity.relationships : {}
  }));

  function changeField(value) {
    if (changeEntity && field) {
      var change = setRelData(field, value);
      changeEntity(change);
    }
  }

  return React.createElement(RelationshipContext.Provider, {
    value: [relChange, changeField]
  }, children);
});

var RelatedEntityList = function RelatedEntityList(props) {
  var relContext = useContext(RelationshipContext);

  if (!relContext) {
    return React.createElement(React.Fragment, null);
  }

  var relField = Object.keys(relContext[0].relationships);

  if (relField.length > 0) {
    var rel = relContext[0].relationships[relField[0]].data;

    if (Array.isArray(rel)) {
      return rel.filter(function (r, i) {
        r.i = i;
        return (r.id || r.local_id) && r.type && r.type === props.type && !(props.maxDisplay && i >= props.maxDisplay);
      }).map(function (r) {
        var i = r.i;
        delete r.i;
        return React.createElement(Entity, Object.assign({}, props, {
          source: r,
          offset: i
        }), props.children);
      });
    }
  }

  return React.createElement(Fragment$1, null);
};

var RelatedEntity = function RelatedEntity(props) {
  var relContext = useContext(RelationshipContext);
  var relFields = relContext ? Object.keys(relContext[0].relationships) : [];

  if (relContext && relFields.length > 0) {
    var relData = relContext[0].relationships[relFields[0]].data;

    if (!Array.isArray(relData)) {
      return React.createElement(Entity, Object.assign({}, props, {
        source: relData
      }), props.children);
    } else if (typeof props.offset === 'number') {
      return React.createElement(Entity, Object.assign({}, props, {
        source: relData[props.offset],
        offset: props.offset
      }), props.children);
    }
  }

  return React.createElement(Entity, Object.assign({}, props), props.children);
};

var UserContext$1 = UserContext;
var UserContextProvider$1 = UserContextProvider;
var Entity$1 = Entity;
var EntityContext$1 = EntityContext;
var attachEntityToRel$1 = attachEntityToRel;
var submitLogin$1 = submitLogin;
var handleLogin$1 = handleLogin;
var handleLogout$1 = handleLogout;
var fetchAuthenticatedContent$1 = fetchAuthenticatedContent;
var isLoggedIn$1 = isLoggedIn;
var Field$1 = Field;
var FieldContext$1 = FieldContext;
var Relationship$1 = Relationship;
var RelationshipContext$1 = RelationshipContext;
var RelatedEntityList$1 = RelatedEntityList;
var RelatedEntity$1 = RelatedEntity;
var SubmitContext$1 = SubmitContext;
var SubmitButtonComponent$1 = SubmitButtonComponent;
export { Entity$1 as Entity, EntityContext$1 as EntityContext, Field$1 as Field, FieldContext$1 as FieldContext, RelatedEntity$1 as RelatedEntity, RelatedEntityList$1 as RelatedEntityList, Relationship$1 as Relationship, RelationshipContext$1 as RelationshipContext, SubmitButtonComponent$1 as SubmitButtonComponent, SubmitContext$1 as SubmitContext, UserContext$1 as UserContext, UserContextProvider$1 as UserContextProvider, attachEntityToRel$1 as attachEntityToRel, fetchAuthenticatedContent$1 as fetchAuthenticatedContent, handleLogin$1 as handleLogin, handleLogout$1 as handleLogout, isLoggedIn$1 as isLoggedIn, submitLogin$1 as submitLogin };